export default "__VITE_ASSET__C_Eckmkm__ 400w, __VITE_ASSET__BDyIEMeQ__ 800w, __VITE_ASSET__c9sPBORB__ 1024w";